import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { Injectable, Output } from '@angular/core';
import { Observable, BehaviorSubject, of, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { TemplateService } from "./template.service";



@Injectable({
  providedIn: 'root'
})
export class DettaglioDateDataSource implements DataSource<ModelEventiCalamitosi.DettaglioDateDTO> {

  public dettaglioDateSubject = new BehaviorSubject<ModelEventiCalamitosi.DettaglioDateDTO[]>([]);
  public campo$ub = this.dettaglioDateSubject.asObservable();
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  private errorSubject = new BehaviorSubject<boolean>(false);
  public loadComplete = new BehaviorSubject<boolean>(false);
  public errors$ = this.errorSubject.asObservable();
  isLoading: boolean = false;
  errorMessage: string = null;

  private countSubject = new BehaviorSubject<number>(null);
  public counter$ = this.countSubject.asObservable();

  constructor(private templateService: TemplateService) {
  }

  loadDate(idEvento: number,
    sortDirection: string,
    pageIndex: number,
    pageSize: number,
    ) {

    this.loadingSubject.next(true);

    this.templateService.getTemplateForTableSegnalazioni(
        pageIndex, pageSize, sortDirection, idEvento
    ).pipe(
      catchError(err => {
        this.errorSubject.next(true);
        return throwError(err);
      }),
      catchError(err => {
        return of([]);
      }),
      finalize(() => this.loadingSubject.next(false))
    )
      .subscribe(result => {
        this.dettaglioDateSubject.next(result['content']);
        this.countSubject.next(result['totalElements']);
      });
  }
  connect(collectionViewer: CollectionViewer): Observable<ModelEventiCalamitosi.DettaglioDateDTO[]> {
    return this.dettaglioDateSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.dettaglioDateSubject.complete();
    this.loadingSubject.complete();
  }

}

